module.exports = __webpack_public_path__ + "static/media/about_bg2_sp.2f0cb3d2.jpg";